import { Loading } from 'element-ui'

export default function (url, param, callback) {
  const loadingInstance = Loading.service({
    fullscreen: true,
    lock: true,
    text: '请求中...',
    body: false,
    background: 'rgba(255, 255, 255, 0.3)'

  });

  const userinfo = sessionStorage.getItem('userinfo') || undefined
  if (userinfo) {
    const { token } = JSON.parse(userinfo)
    param.token = token
  }
  this.$http.post(url, param).then(result => {
    loadingInstance.close()
    callback(result.data, result.ret === 200, result.msg, result);
  }).catch(e => {
    loadingInstance.close()
    console.log(e)
  });
}


// WEBPACK FOOTER //
// ./src/utils/post.js